import { isEmpty } from "lodash";
import * as yup from "yup";

const borrowerInfoValidation = yup.object().shape({
  firstName: yup.string().required("First Name is required.").min(2).max(200),
  lastName: yup.string().required("Last Name is required.").min(2).max(200),
  email: yup.string().required("Email is required.").email("Must be a valid email").max(200),
  phoneNumber: yup
    .string()
    .nullable()
    .transform(value => (isEmpty(value) ? undefined : value))
    .matches(/(^\d{10}$)/, "This is not a valid phone number", { excludeEmptyString: true }),
  mobileNumber: yup
    .string()
    .nullable()
    .transform(value => (isEmpty(value) ? undefined : value))
    .matches(/(^\d{10}$)/, "This is not a valid phone number", { excludeEmptyString: true }),
  ficoScore: yup
    .number()
    .transform(v => (Number.isNaN(v) ? 0 : v))
    .default(0)
    .required("This field is required")
    .min(350, "Minimum FICO Score must be greater than or equal to 350.")
    .max(850, "Maximum FICO Score must be less than or equal to 850."),
  liquidity: yup
    .number()
    .transform(v => (Number.isNaN(v) ? 0 : v))
    .default(0)
    .required("This field is required")
    .moreThan(0, "Liquidity must be greater than 0"),
  netWorth: yup
    .number()
    .transform(v => (Number.isNaN(v) ? 0 : v))
    .default(0),
  ownershipPercentage: yup
    .number()
    .transform(v => (Number.isNaN(v) ? 0 : v))
    .default(0),
  isUsCitizen: yup.bool().nullable().default(true),
  hasBeenBankruptcy: yup.bool().nullable().default(false),
});

export default borrowerInfoValidation;

